import React, {useState} from "react";
import "./AllEvents.css";
import EventInfo from "./EventInfo.js";
import moment from 'moment';


const AllEvents = function (props) {
    const startDate = moment(props.data.MuseumEventStartDate).format("D.MM");
    const endDate = moment(props.data.MuseumEventEndDate).format("D.MM");
    // const startTime = props.data.MuseumEventStartHour;
    // const endTime = props.data.MuseumEventEndHour;
    const [showEventDisplay,setShowEventDisplay] = useState(false);
    const displaySelectedEvent = () => {
        setShowEventDisplay(!showEventDisplay);
    }
    return (       
        <React.Fragment>
            <div className="completeEvent">
                <div className={showEventDisplay ?"singleEventDisplay singleEventDisplayShadow":"singleEventDisplay"} onClick={displaySelectedEvent}>
                    <div className="iconAreaEvent">
                        <img className="iconSingleEvent" src={props.data.MuseumEventIcon_Url} data-holder-rendered="true"  alt={"אייקון אירוע " + props.data.MuseumEventName}/>
                    </div>
                    <div className="eventDisplayInfo eventDisplayInfoMuseumName">
                        <span className="eventVisibleTitle">{props.data.MuseumEventName}</span>
                    </div>
                    <div >
                        <span className="middleEventSeparator">&nbsp;</span>
                    </div>
                    <div className="eventDisplayInfo eventMobileNotVisible">
                        <span>{props.data.Title}</span>
                    </div>
                    <div >
                        <span className="middleEventSeparator">&nbsp;</span>
                    </div>
                    <div className="eventDisplayInfo eventMobileNotVisible">
                        <span>{endDate} - {startDate}</span>
                    </div> 
                    <div className= {showEventDisplay?"visible eventDisplayInfoArrow" : "eventDisplayInfoArrow"}>
                        <i className= {showEventDisplay?"fas fa-sort-up" : "fas fa-sort-down"}></i>
                    </div>  
                </div>  
                <div className={showEventDisplay ?"":"completeEventInfoVisible"}>
                    <EventInfo items={props.data}/>
                </div> 
            </div>
        </React.Fragment>
    );
}

export default AllEvents;
